import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";
import { Contract } from "@edp-components/edp-contract";
import { Menu } from "@edp-models/menu.model";
import { AppBannerService } from "@edp-services/app-banner.service";
import { OperationHistoryService } from "@edp-services/operation-history.service";
import { getMainMenu } from "@edp-store/selectors/layout.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { OperationHistoryEsEnum } from "@edp-enums/ES/operation-history-es-enum";
import { select, Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { of } from "rxjs";
import { filter, switchMap, take } from "rxjs/operators";
import { IAppEsState } from "@edp-store/state/ES/app-es.state";
import { getContractEs } from "@edp-store/selectors/ES/contract-es.selectors";
import { ContractEs } from "@edp-models/ES/es-contract.model";

@Component({
    selector: "edp-e-sidebar-sub-level",
    templateUrl: "./edp-e-sidebar-sub-level.component.html",
    styleUrls: ["./edp-e-sidebar-sub-level.component.scss"],
})
export class EdpESidebarSubLevelComponent implements OnChanges {
    @Input() contract: Contract;
    contractES: ContractEs;
    @Output() closeSidebarSublevel = new EventEmitter();
    @Output() closeSidebar = new EventEmitter();

    public homepage: string[];
    public linkToRedirect: string;
    public menu$ = this.store.pipe(
        select(getMainMenu),
        filter(menu => menu.length > 0),
        switchMap(menu => {
            const menuSelected = menu.find(item => item.isActive);
            this.isEnergy = menuSelected && menuSelected.grouping === "energia";

            return of(menuSelected ? menuSelected.submenu : []);
        })
    );
    public isEnergy: boolean;
    public showAppBanner = false;

    constructor(
        private readonly store: Store<IAppState>,
        private readonly storeES: Store<IAppEsState>,
        private readonly translate: TranslateService,
        private readonly operationHistoryService: OperationHistoryService,
        private readonly router: Router,
        private readonly appBannerService: AppBannerService
    ) {
        this.showAppBanner = this.appBannerService.show();

        this.storeES
            .select(getContractEs)
            .pipe(filter(c => !!c))
            .subscribe(contractES => (this.contractES = contractES));
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.contract.currentValue) {
            this.getEnergyLink(changes.contract.currentValue);
            this.homepage = [`/energia/${changes.contract.currentValue.ContractId}/inicio`];
        }
    }

    public getEnergyLink = (contract: Contract): string => {
        let link = "pt.edp.edponline.pack.new-contract-link";

        if (contract.isSmallBusiness()) {
            link = "pt.edp.edponline.pack.new-contract-link-small-business";
        }

        return this.translate.instant(link);
    };

    public itemAction(item: Menu) {
        this.getNameOperation(item);

        if (item.callToAction) {
            item.callToAction();
        }

        if (item.routerPath[0].includes("consumos")) {
            if (!this.contract.SmartNow || (!!this.contract.SmartNow && !this.contract.SmartNow.ActivationDate)) {
                this.router.navigate(item.routerPath, { queryParamsHandling: "preserve" });
            }

            if (!!this.contract.SmartNow && !!this.contract.SmartNow.ActivationDate) {
                this.router.navigate([item.routerPath[0]], { queryParamsHandling: "preserve" });
            }
        } else {
            this.router.navigate(item.routerPath, { queryParamsHandling: "preserve" });
        }

        this.closeSidebar.emit();
        if (item.operationHistory) {
            this.sendOperationHistoryService(item.operationHistory);
        }
    }

    private getNameOperation(item: Menu) {
        const label = item.name.replace(/[MENU. ]+/g, "").toUpperCase();
        this.sendOperationHistoryService(OperationHistoryEsEnum[label]);
    }

    private sendOperationHistoryService(key: string, value: string | null = null) {
        const contractId = !!this.contract?.ContractId ? this.contract.ContractId : this.contractES ? this.contractES.id : null;
        this.operationHistoryService.registerWithContract(contractId, key, value, null, null, false);
    }
}
